import { createContext, useContext } from 'react';
import { IMobileNativeSelectOption } from '~/src/dash/components/dropdowns/MobileNativeSelect';

export interface IMobileDashboardStore {
  tabs: IMobileNativeSelectOption[];
  activeTab: number;
  handleChangeTab: (v: string | number) => void;
}

export const MobileDashboardStore = createContext({} as IMobileDashboardStore);
export const useMobileDashboardStore = (): IMobileDashboardStore =>
  useContext(MobileDashboardStore);
